export function getReferrer() {
  return document.referrer;
}